import { useEffect, useState, useRef, useCallback } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Ribbon } from "@/components/site/Ribbon";
import { BrandStrip } from "@/components/site/BrandStrip";
import { OffersBar, OffersBanner } from "@/components/site/Offers";
import { VehicleShowcase } from "@/components/site/VehicleShowcase";
import { Legacy } from "@/components/site/Legacy";
import { BookingForms } from "@/components/site/BookingForms";
import { Locations } from "@/components/site/Locations";
import { Footer } from "@/components/site/Footer";
import { fetchOffers } from "@/lib/api";
import Dashboard from "@/pages/Dashboard";

function Landing() {
  const [prefill, setPrefill] = useState("");
  const [offers, setOffers] = useState([]);
  const [barOpen, setBarOpen] = useState(true);
  const lenisRef = useRef(null);

  useEffect(() => {
    fetchOffers().then((r) => setOffers(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const scrollTo = useCallback((sel) => {
    const lenis = lenisRef.current;
    if (lenis) lenis.scrollTo(sel, { offset: -80, duration: 1.2 });
    else document.querySelector(sel)?.scrollIntoView({ behavior: "smooth" });
  }, []);

  const enquire = useCallback((vehicle) => {
    if (vehicle) setPrefill(vehicle);
    setTimeout(() => scrollTo("#enquire"), 60);
  }, [scrollTo]);

  const showBar = barOpen && offers.length > 0;

  return (
    <div className="bg-[#0a0a0a] text-white min-h-screen antialiased">
      <OffersBar offers={offers} show={showBar} onClose={() => setBarOpen(false)} />
      <Navbar onNav={scrollTo} topOffset={showBar ? 40 : 0} />
      <main>
        <Hero onExplore={() => scrollTo("#vehicles")} onEnquire={() => enquire("")} />
        <Ribbon />
        <BrandStrip />
        <OffersBanner offers={offers} />
        <VehicleShowcase onEnquire={enquire} />
        <Legacy />
        <BookingForms prefillVehicle={prefill} onConsumed={() => setPrefill("")} />
        <Locations />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Dashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
